import { render, staticRenderFns } from "./QuotationsClient.vue?vue&type=template&id=4e134a0b&"
import script from "./QuotationsClient.vue?vue&type=script&lang=js&"
export * from "./QuotationsClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports